import React, { useMemo } from "react";

import { LeftOutlined } from "@ant-design/icons";

import PaymentPendingBanner from "../../../../grace-period/components/PaymentPendingBanner";
import StyledTooltip from "../../../../Common/UIComponents/StyledTooltip";

import { PICKUP_WIZARD_STEPS } from "../../../Common/utils";
import { isLocalCourierType, PICKUP_TYPE_KEYS } from "../utils";

import { ReactComponent as CheckboxCircleFillIcon } from "../../../../../assets/icons/Supply & Pickup/checkbox-circle-fill.svg";
import { ReactComponent as TruckIcon } from "../../../../../assets/icons/Supply & Pickup/truck.svg";

import "./CreateStepLayout.css";

export default function CreateStepLayout({
  pickupTypeLabel = "FedEx Pickup",
  pickupTypeKey,
  activeStepKey = "select-submissions",
  allStepsComplete = false,
  onBack,
  children,
  footer = null,
}) {
  const wizardSteps = useMemo(() => {
    let steps = PICKUP_WIZARD_STEPS;
    if (isLocalCourierType(pickupTypeKey)) {
      steps = steps.filter((step) => step.key !== "packaging-boxes");
    }
    if (pickupTypeKey === PICKUP_TYPE_KEYS.FEDEX_DROPOFF) {
      steps = steps.map((step) => (
        step.key === "pickup-schedule"
          ? { ...step, label: "Address Details" }
          : step
      ));
    }
    return steps;
  }, [pickupTypeKey]);

  const activeIndex = allStepsComplete
    ? wizardSteps.length
    : Math.max(
      0,
      wizardSteps.findIndex((step) => step.key === activeStepKey),
    );

  return (
    <div className="CreateStepLayout">
      <div className="CreateStepLayout__TopBar">
        <div className="CreateStepLayout__TopBarLeft">
          <StyledTooltip title="Back" placement="top">
            <button
              type="button"
              className="CreateStepLayout__BackBtn"
              onClick={onBack}
              aria-label="Back"
            >
              <LeftOutlined />
            </button>
          </StyledTooltip>
          <span className="CreateStepLayout__PickupType">
            <TruckIcon className="CreateStepLayout__PickupTypeIcon" aria-hidden />
            {pickupTypeLabel}
          </span>
        </div>

        <div className="CreateStepLayout__Stepper" role="list">
          {wizardSteps.map((step, index) => {
            const isActive = index === activeIndex;
            const isComplete = index < activeIndex;
            return (
              <div
                key={step.key}
                role="listitem"
                className={[
                  "CreateStepLayout__Step",
                  isActive ? "CreateStepLayout__Step--active" : "",
                  isComplete ? "CreateStepLayout__Step--complete" : "",
                ].filter(Boolean).join(" ")}
              >
                <span className="CreateStepLayout__StepIndex">
                  {isComplete ? (
                    <CheckboxCircleFillIcon
                      className="CreateStepLayout__StepCompleteIcon"
                      aria-hidden
                    />
                  ) : (
                    index + 1
                  )}
                </span>
                <span className="CreateStepLayout__StepLabel">{step.label}</span>
              </div>
            );
          })}
        </div>
      </div>

      <PaymentPendingBanner />
      <div className="CreateStepLayout__Body">{children}</div>
      {footer}
    </div>
  );
}
